<template>
  <div class="rightTableDiv">
    <search-form @setSearchCondition="setSearchCondition" @clearSearch="clearSearch" @changeScrollY="changeScrollY" @saveAdvanced="saveAdvanced" class="searchFormDiv"></search-form>
    <a-table
      class="assetTable"
      id="assetTable"
      bordered
      :columns="columns"
      :rowKey="record => record.id"
      :dataSource="tableData.data"
      :pagination="pagination"
      :loading="tableData.loading"
      @change="handleTableChange"
      :scroll="{ y: scrollY, x: 1400 }"
      :expandedRowKeys="expandedRowKeys"
      :row-selection="rowSelection"
      expandRowByClick
      :expandIcon="expandIcon"
      :expandIconAsCell="false"
      :expandIconColumnIndex="3"
      :rowClassName="rowClassName">
      <template slot="icon" slot-scope="text, record">
        <div class="assetNameTable">
          <!--          展开按钮表格内显示-->
          <div @click="showLine(record)" class="expandBtn">
            <div role="button" tabindex="0" aria-label="关闭行" class="ant-table-row-expand-icon ant-table-row-expanded" v-if="expandedRowKeys[0] === text.id"></div>
            <div role="button" tabindex="0" aria-label="展开行" class="ant-table-row-expand-icon ant-table-row-collapsed" v-else></div>
          </div>
        </div>
      </template>
      <template slot="x1" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.txt50 }}</template>
            <span class="txt50Span">{{ record.txt50 }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="gdlgrpTxt" slot-scope="text, record">
        <a-button class="blueBtn" ghost size="small" v-if="record.gdlgrpTxt === '融资租入'">融资租入</a-button>
        <a-button class="orangeBtn" ghost size="small" v-if="record.gdlgrpTxt === '经营租出'">经营租出</a-button>
        <a-button class="greenBtn" ghost size="small" v-if="record.gdlgrpTxt === '自用'">自用</a-button>
        <a-button class="greenBtn" ghost size="small" v-if="record.gdlgrpTxt === '抵押'">抵押</a-button>
      </template>
      <!--      责任人-->
      <template slot="raumn" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.raumn }}</template>
            <span class="txt50Span">{{ record.raumn }}</span>
          </a-tooltip>
        </div>
      </template>
      <!--      购置价值/万元-->
      <template slot="kansw" slot-scope="text, record">
        <div class="assetNameTable">
          <a-tooltip>
            <template slot="title">{{ record.ykansw }}</template>
            <span class="txt50Span">{{ record.kansw }}</span>
          </a-tooltip>
        </div>
      </template>
      <template slot="expandedRowRender" slot-scope="record">
        <div class="expand_row">
          <!-- 占位 -->
          <div class="expand_left"></div>
          <!-- 展开显示的内容 -->
          <div class="expand_right">
            <data-tabs ref="dataTabs" :model="expandedRowKeys[0] === record.id ? record : null"></data-tabs>
          </div>
        </div>
      </template>
      <template slot="actions" slot-scope="text, record">
        <a href="javascript:;" @click.stop="() => handleEdit(record)">预览</a>
        <a-divider type="vertical"/>
        <a href="javascript:;" @click.stop="() => handleEdit(record)">下载</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import SearchForm from '@/views/fileManagement/modules/searchForm'
import { getTableData, getDeptTreeList } from '@/api/fileManagement'
import DataTabs from './dataTabs.vue'
import { getTableScroll } from '@/views/fileManagement/modules/height'
import { mapGetters } from 'vuex'
export default {
  name: 'TableData',
  components: {
    DataTabs,
    SearchForm
  },
  computed: {
    ...mapGetters(['fileManagementCompanyId', 'fileManagementAnlkl']),
    columns () {
      let { sortedInfo } = this
      sortedInfo = sortedInfo || {}
      const columns = [
        {
          title: '',
          scopedSlots: {
            customRender: 'icon'
          },
          align: 'center',
          width: 40
        },
        {
          title: '序号',
          customRender: (text, record, index) => {
            return index + 1
          },
          align: 'center',
          width: 40
        },
        {
          title: '档案件',
          dataIndex: 'x1',
          scopedSlots: {
            customRender: 'x1'
          },
          sorter: (a, b) => {},
          sortOrder: sortedInfo.columnKey === 'x1' && sortedInfo.order,
          align: 'center'
          // width: 170
        },
        {
          title: '档案件编号',
          dataIndex: 'assetNumber',
          sorter: (a, b) => {},
          sortOrder: sortedInfo.columnKey === 'assetNumber' && sortedInfo.order,
          align: 'center',
          width: 250
        },
        {
          title: '成文日期',
          dataIndex: 'gdlgrpTxt1',
          align: 'center',
          width: 200
        },
        {
          title: '整体形式',
          dataIndex: 'ordtx',
          sorter: (a, b) => {},
          sortOrder: sortedInfo.columnKey === 'ordtx' && sortedInfo.order,
          align: 'center',
          width: 130
        },
        {
          title: '密级',
          dataIndex: 'x2',
          align: 'center',
          width: 130
        },
        {
          title: '文件类型',
          dataIndex: 'raumn',
          scopedSlots: {
            customRender: 'raumn'
          },
          sorter: (a, b) => {},
          sortOrder: sortedInfo.columnKey === 'raumn' && sortedInfo.order,
          align: 'center',
          width: 130
        },
        {
          title: '保留期限',
          dataIndex: 'kansw',
          scopedSlots: {
            customRender: 'kansw'
          },
          sorter: (a, b) => {},
          sortOrder: sortedInfo.columnKey === 'kansw' && sortedInfo.order,
          align: 'center',
          width: 200
        },
        {
          title: '操作',
          scopedSlots: {
            customRender: 'actions'
          },
          align: 'center',
          width: 115
        }
      ]
      return columns
    }
  },
  data () {
    return {
      searchValue: '',
      // 表格数据
      tableData: {
        data: [],
        statistics: {
          mengeSum: 0,
          kanswSum: 0,
          qmjzSum: 0
        },
        loading: false
      },
      sortedInfo: null,
      scrollY: 0,
      toLeftWidth: 0,
      advanced: false,
      // 搜索条件
      searchModel: {},
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40'],
        showSizeChanger: true,
        showQuickJumper: true
      },
      sort: {},
      // 展开的行
      expandedRowKeys: [],
      // 选中的行
      selectedRows: [],
      rowSelection: {
        columnWidth: 40,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectedRows = selectedRows
        }
      },
      // 左侧树的搜索条件
      treeSearchModel: {}
    }
  },
  created () {
    // 获取表格数据
    // this.getDeptData()
  },
  mounted () {

  },
  watch: {
    fileManagementCompanyId (newValue) {
      // if (newValue.id !== '') {
      //   if (newValue.id === '空') {
      //     delete this.treeSearchModel.comid
      //     this.tableData.data = []
      //     this.pagination.total = 0
      //     this.tableData.loading = false
      //     const dom = document.getElementsByClassName('ant-table-body')[0]
      //     dom.classList.add('ant-table-body-max-height-0')
      //     if (this.advanced) {
      //       this.changeScrollY(90, 'addAssetTableHeigth')
      //     } else {
      //       this.changeScrollY(94)
      //     }
      //   } else {
      //     this.treeSearchModel.comid = newValue.id
      //   }
      // } else {
      //   delete this.treeSearchModel.comid
      // }
      // delete this.searchModel.comid
      // if (newValue.id !== '空') {
        this.setSearchCondition(this.searchModel)
      // }
    },
    fileManagementAnlkl (newValue) {
      // if (newValue.anlkl !== '' && newValue.anlkl !== '资产分类') {
      //   if (newValue.anlkl === '空') {
      //     delete this.treeSearchModel.anlkl
      //     this.tableData.data = []
      //     this.pagination.total = 0
      //     this.tableData.loading = false
      //     const dom = document.getElementsByClassName('ant-table-body')[0]
      //     dom.classList.add('ant-table-body-max-height-0')
      //     if (this.advanced) {
      //       this.changeScrollY(90, 'addAssetTableHeigth')
      //     } else {
      //       this.changeScrollY(94)
      //     }
      //   } else {
      //     this.treeSearchModel.anlkl = newValue.anlkl
      //   }
      // } else {
      //   delete this.treeSearchModel.anlkl
      // }
      // delete this.searchModel.anlkl
      // if (newValue.anlkl !== '空') {
        this.setSearchCondition(this.searchModel)
      // }
    }
  },
  methods: {
    // 隐藏展开图标
    expandIcon (props) {
      return null
    },
    // 判断是否展开行
    showLine (expanded, record) {
      // 只展开一行
      if (this.expandedRowKeys.length > 0) { // 进这个判断说明当前已经有展开的了
        // 返回某个指定的字符串值在字符串中首次出现的位置，下标为0
        const index = this.expandedRowKeys.indexOf(expanded.id)
        if (index > -1) { // 如果出现则截取这个id,1d到1相当于0，针对重复点击一个
          this.expandedRowKeys.splice(index, 1)
        } else {
          // 如果没出现则截取所有id,添加点击id，0到1，针对已经有一个展开，点另一个会进入判断
          this.expandedRowKeys.splice(0, this.expandedRowKeys.length)
          this.expandedRowKeys.push(expanded.id)
        }
      } else {
        // 数组长度小于0，说明都没展开，第一次点击，id添加到数组，数组有谁的id谁就展开
        this.expandedRowKeys.push(expanded.id)
      }
    },
    rowClassName (record, index) {
      return (record.id === this.expandedRowKeys[0]) ? 'activeHighLight' : ''
    },
    // 改变scrollY
    changeScrollY (extraHeight, type) {
      this.$nextTick(() => {
        this.scrollY = getTableScroll(extraHeight, 'assetTable', type)
        const dom = document.getElementById('assetTable')
        if (type === 'addAssetTableHeigth') {
          dom.classList.add('assetTableHeight_126')
        } else {
          dom.classList.remove('assetTableHeight_126')
        }
      })
    },
    // 保存展开状态字段
    saveAdvanced (advanced) {
      this.advanced = advanced
    },
    //  获取部门树用于第一次请求表格
    getDeptData () {
      const data = {
        paging: false,
        id: 0
      }
      getDeptTreeList(data).then(res => {
        if (res.status === 0) {
          this.treeSearchModel.comid = res.data[0].id
          this.setSearchCondition(this.searchModel)
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 获取表格数据
    getTableData (type) {
      for (let i = 0; i < 20; i++) {
        this.tableData.data.push({
          id: i,
          x1: '档案' + (i + 1),
          txt50: '档案' + (i + 1),
          assetNumber: '101010100000220120012',
          gdlgrpTxt1: '2022-12-12',
          ordtx: 'xxx',
          x2: 'A类',
          raumn: 'xxxx',
          kansw: '2033-12-12'
        })
      }
      if (this.advanced) {
        this.changeScrollY(50, 'addAssetTableHeigth')
      } else {
        this.changeScrollY(54)
      }
      return
      this.tableData.loading = true
      this.searchModel = { ...this.searchModel, ...this.pagination, ...this.sort }
      this.expandedRowKeys = []
      getTableData(this.searchModel).then(res => {
        if (res.status === 0) {
          // const dom = document.getElementsByClassName('ant-table-body')[0]
          if (res.data.list.length > 0) {
            // dom.classList.remove('ant-table-body-max-height-0')
            for (let i = 0; i < res.data.list.length; i++) {
              const item = res.data.list[i]
              item.id = i
            }
          } else {
            // dom.classList.add('ant-table-body-max-height-0')
          }
          this.tableData.data = res.data.list
          this.pagination.total = res.data.total
          console.log(this.tableData)
          this.tableData.loading = false
          if (this.advanced) {
            this.changeScrollY(50, 'addAssetTableHeigth')
          } else {
            this.changeScrollY(54)
          }
        } else {
          this.tableData.data = []
          this.tableData.total = 0
          this.tableData.loading = false
          this.$message.error(res.info.message)
        }
      })
    },
    // 搜索
    setSearchCondition (searchModel) {
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = searchModel
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel, ...searchModel }
      this.getTableData()
    },
    // 重置
    clearSearch (searchModel) {
      this.sort = {}
      this.sortedInfo = null
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = searchModel
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel }
      this.getTableData()
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.sortedInfo = sorter
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      if (sorter.field === 'ordtx') {
        this.sort.sortName = 'ord43'
      } else if (sorter.field === 'txk20') {
        this.sort.sortName = 'anlkl'
      } else if (sorter.field === 'x1') {
        this.sort.sortName = 'txt50'
      } else {
        this.sort.sortName = sorter.field
      }
      if (sorter.order) {
        if (sorter.order === 'ascend') {
          this.sort.sortType = 'asc'
        } else if (sorter.order === 'descend') {
          this.sort.sortType = 'desc'
        }
      } else {
        delete this.sort.sortName
        delete this.sort.sortType
        delete this.searchModel.sortName
        delete this.searchModel.sortType
      }
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel }
      this.getTableData('changePageNum')
    }
  }
}
</script>

<style scoped lang="less">
.rightTableDiv {
  height: 100%;
}
.listContent {
  .table {
    margin-top: 10px;
  }
}
.ant-table-row-collapsed::after {
  content: '+';
  color: #DDDDDD;
}
.ant-table-row-expanded::after {
  content: '-';
  color: #DDDDDD;
}
/deep/.ant-table-footer {
  padding: 0 !important;
  height: 40px;
  .footerDiv {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #E7F4FF;
    height: 100%;
    font-size: 14px;
    font-weight: 500;
    .footerDivOne ,.footerDivTwo ,.footerDivThree {
      width: 33.33%;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 0 20px;
      color: #333333;
      span:first-child {
        //margin-right: 20px;
      }
    }
    .footerDivOne {
      border-right: 1px solid #DDDDDD;
    }
    .footerDivTwo {
      border-right: 1px solid #DDDDDD;
    }
  }
}
/deep/.ant-table-expanded-row{
  >td{
    padding: 0;
    .expand_row{
      display: flex;
      .expand_left{
        width: 80px;
        border-right: 1px solid #e8e8e8;
      }
      .expand_right{
        width: calc(100% - 80px);
        //padding: 0 10px 8px 10px;
      }
    }
  }
}
// /deep/.ant-table-pagination.ant-pagination {
//   margin: 10px 0 0 0 !important;
// }
/deep/.ant-table-wrapper.assetTable  {
  transition: height 300ms ease;
  height: calc(100% - 42px);
  >.ant-spin-nested-loading {
    height: 100%;
    >.ant-spin-container {
      height: calc(100% - 43px);
      .ant-table {
        height: 100%;
        .ant-table-content {
          height: 100%;
          .ant-table-scroll{
            height: 100%;
            .ant-table-body {
              transition: max-height 300ms ease;
              height: calc(100% - 40px);
            }
          }
        }
      }
      >.ant-table-pagination.ant-pagination {
        margin: 10px 0 0 0 !important;
      }
    }
  }
  .ant-table-pagination.ant-pagination {
    margin: 10px;
  }
  // /deep/.ant-table-bordered{
  //   .ant-table-thead > tr > th,
  //   .ant-table-tbody > tr > td{
  //     border-color: #DDDDDD;
  //   }
  //   .ant-table-header > table,
  //   .ant-table-body > table,
  //   .ant-table-fixed-left table,
  //   .ant-table-fixed-right table{
  //     border-color: #DDDDDD;
  //   }
  // }
}
.assetTableHeight_126 {
  height: calc(100% - 126px) !important;
}
.assetNameTable {
  .txt50Span {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }
  //width: 100%;
  //display: flex;
  //flex-direction: row;
  //align-items: center;
  .expandBtn {
    //margin-right: 5px;
  }
}
.blueBtn {
  background: rgba(23, 145, 255, 0.1) !important;
  color: #1791FF;
  border: 1px solid rgba(23, 145, 255, 0.7) !important;
}
.orangeBtn {
  background: rgba(255, 142, 59, 0.1) !important;
  color: #FF8E3B;
  border: 1px solid rgba(255, 142, 59, 0.7) !important;
}
.greenBtn {
  background: rgba(54, 191, 125, 0.1) !important;
  color: #36BF7D;
  border: 1px solid rgba(54, 191, 125, 0.7) !important;
}
/deep/.ant-table-align-center {
  padding: 0 !important;
}
/deep/.ant-table-body-max-height-0 {
  max-height: 0 !important;
}
/deep/.ant-table-tbody .activeHighLight{
  background-color: #e6f7ff !important;
}
/deep/.ant-table-placeholder {
  position: absolute;
  background: none;
  border-top: none;
  border-bottom: none;
  border-radius: 0 0 4px 4px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 100px;
  .ant-empty-normal {
    margin: 0 !important;
  }
}
</style>
